import { useState } from "react";
import { DeleteButton, StandardButton } from "../atoms/buttons";
import { UpDownButton } from "./createLessonContent";

export function LessonContentComp({inputs,remove,moveUp,moveDown}) {
    const [currentlyRemoved, setCurrentlyRemoved] = useState(false)
    const scrollNow = (event) => {

        event.stopPropagation()


      };
    
    function removeContent(e) {
        setCurrentlyRemoved(true)
        remove(e)
    }

    return(
        <div onClick={(event) => scrollNow(event)} className={`vertical standard-padding heavy-border standard-rounded card-background-color lesson-content`} style={{width:"unset"}}>
           {moveUp && <UpDownButton icon={"arrow-up"} onClick={moveUp}/>}
            {inputs}
            <div className="horizontal space-between standard-margin-top">
                <DeleteButton onClick={(e) => removeContent(e)} size={"primary-background-100 white-color"} title={"Verwijder"}/>
               { moveDown && <UpDownButton onClick={moveDown} icon={"arrow-down2"}/>}
                <StandardButton size={"primary-background-600 white-color"} title={"Opslaan"}/>
            </div>
        </div>
    )
}